var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('node-view-wrapper',{attrs:{"as":"span"}},[_c('b-link',{staticClass:"internal-link",attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.node.attrs.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }